import styled from 'styled-components';
import { Alert, Button, Form, Input } from 'antd';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
`;

export const Title = styled.h2`
  font-size: 16px;
  font-weight: 400;
  padding: 20px 20px 40px 20px;
`;

export const StyledForm = styled(Form.Item)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const FormRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

export const Label = styled.label`
  font-size: 14px;
  min-width: 120px;
  width: 120px;
`;

export const InputGroup = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  span {
    margin: 0 5px;
  }
`;

export const StyledInput = styled(Input)`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
  width: 100%;
`;

export const RadioButtonGroup = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
`;

export const RadioButton = styled.div<{ active?: boolean }>`
  flex: 1;
  padding: 10px;
  border: 1px solid ${({ active }) => (active ? '#225f9b' : '#aaa')};
  background-color: ${({ active }) => (active ? '#ffffff' : '#F2F2F2')};
  color: ${({ active }) => (active ? '#225f9b' : '#aaa')};
  cursor: pointer;
  text-align: center;
  border-radius: 4px;

  &:hover {
    border-color: #225f9b;
    color: #225f9b;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const VerifyButton = styled(Button)`
  border-radius: 4px;
  color: white;
  background-color: #225f9b;

  span {
    padding: 0 20px;
    color: white;
    border: none;
  }

  &:hover {
    background-color: #1a4a75;
    border: none;
  }
`;

export const StyledAlert = styled(Alert)`
  margin-bottom: 20px;
`;
